import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-md px-3 py-1 text-xs uppercase tracking-wide transition-colors",
  {
    variants: {
      variant: {
        default:
          "bg-[#006747] text-white hover:bg-[#00553a]",
        success:
          "bg-[#a7f3d0] text-[#065f46] hover:bg-[#86efac]",
        warning:
          "bg-[#fed7aa] text-[#9a3412] hover:bg-[#fdba74]",
        destructive:
          "bg-[#fecaca] text-[#991b1b] hover:bg-[#fca5a5]",
        secondary:
          "bg-[#e2e8f0] text-[#334155] hover:bg-[#cbd5e1]",
        outline:
          "border border-slate-300 text-slate-700 bg-white",
        info:
          "bg-[#bae6fd] text-[#0369a1] hover:bg-[#7dd3fc]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
  VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
